import { render, staticRenderFns } from "./EditUserForm.vue?vue&type=template&id=4dfec6c0&"
import script from "./EditUserForm.vue?vue&type=script&lang=ts&"
export * from "./EditUserForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports